export default "__VITE_ASSET__78a5b3fe__"